/* global pintrk, fbq */

export function trackPinterestEvent(type, data = null) {

    if (typeof (pintrk) === 'function') {
        pintrk('track', type, data);
    }
}

export function trackFacebookPixelEvent(type, data = null) {

    if (typeof (fbq) === 'function') {
        fbq('track', type, data);
    }
}